import React from 'react';
import '../assets/styles/styles.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer>
      <p>&copy; {currentYear} Gandhi Ashram Tiruchengode </p>
      <p>Powered by <a href="https://veeranardinnovations.com/" target="_blank" rel="noopener noreferrer">Veerana R&D Innovations 24/7</a></p>
    </footer>
  );
};

export default Footer;
